import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

function installChunkLoadRecovery() {
  // Handles cached/stale chunk references after a deploy (common on CDNs).
  // Reload once per tab session to fetch the latest HTML + chunk map.
  const RELOAD_KEY = 'scribe_chunkload_reload_once';

  const shouldRecover = (message) => {
    const m = String(message || '');
    return (
      m.includes('ChunkLoadError') ||
      /Loading (CSS )?chunk \d+ failed/i.test(m) ||
      /Loading CSS chunk \d+ failed/i.test(m)
    );
  };

  const recover = () => {
    try {
      if (sessionStorage.getItem(RELOAD_KEY) === '1') return;
      sessionStorage.setItem(RELOAD_KEY, '1');

      const url = new URL(window.location.href);
      url.searchParams.set('__reload', String(Date.now()));
      window.location.replace(url.toString());
    } catch {
      // As a fallback, do a plain reload.
      window.location.reload();
    }
  };

  window.addEventListener('error', (event) => {
    // Script/CSS errors sometimes surface as generic ErrorEvent.
    if (shouldRecover(event?.message)) recover();
  });

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event?.reason;
    const msg = reason?.message || reason?.toString?.() || String(reason || '');
    if (shouldRecover(msg)) recover();
  });
}

installChunkLoadRecovery();

const root = ReactDOM.createRoot(document.getElementById('root'));
const RootWrapper = process.env.NODE_ENV === 'development' ? React.Fragment : React.StrictMode;
root.render(
  <RootWrapper>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </RootWrapper>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
